import React from 'react'
import { EcomProduct } from '../../../../models/axiosModel';
import { Divider, Grid, Typography } from '@mui/material';
import mappingStyles from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import globalStyles from "../../../../assets/styles/global.module.scss";
import CreateSingleProduct from './createSingleProduct';


interface EditProductPopupProps {
    selectedProduct: EcomProduct, 
    getEComProductApiCall: () => Promise<void>, 
    setFlagEditProductPopup: React.Dispatch<React.SetStateAction<boolean>>,
    getWhatsAppCatalogsDataApiCall: () => Promise<void>,
    getCatalogProductOptionalFieldApiCall: () => Promise<void>,
} 

const EditProductPopup: React.FC<EditProductPopupProps> = (props) => {

    const {selectedProduct, getEComProductApiCall, setFlagEditProductPopup, getWhatsAppCatalogsDataApiCall, getCatalogProductOptionalFieldApiCall} = props; 
    const innerHeight = window.innerHeight - 130;

    const onClickOfCancel = () => {
        setFlagEditProductPopup(false);
    }

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={mappingStyles.popupTitleTypography}>Edit Product</Typography>
                        </Grid>

                        <Divider className={mappingStyles.popupTitleDivider} /> 

                        <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`} sx={{maxHeight: `${innerHeight}px !important`}}>
                            <Grid container className={mappingStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <CreateSingleProduct
                                        getEComProductApiCall={getEComProductApiCall}
                                        selectedProduct={selectedProduct} 
                                        onClickOfCancel={onClickOfCancel}
                                        getWhatsAppCatalogsDataApiCall={getWhatsAppCatalogsDataApiCall}
                                        getCatalogProductOptionalFieldApiCall={getCatalogProductOptionalFieldApiCall}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default EditProductPopup
